import { Component, signal } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { HeaderComponent } from "./header/header.component";
import { NavigationComponent } from "./navigation/navigation.component";
import { CommonModule } from "@angular/common";
import { FooterComponent } from "../shared/components/footer/footer.component";

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    imports: [
        NavigationComponent,
        HeaderComponent,
        RouterOutlet,
        CommonModule,
        FooterComponent
    ]
})
export class LayoutComponent {
  showContent = signal<boolean>(true);

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showContent.set(!event.url.includes('/help'));
      }
    });
  }
}
